import React from "react";
import { isHeats, isFinals, isExtremeQualification, isNotExtremeQualification, isTeam } from "components/sports/csl/helper/CslHelpers";
import CslHeats from "components/sports/csl/views/CslHeats";
import CslFinals from "components/sports/csl/views/CslFinals";
import CslExtremeQualification from "components/sports/csl/views/CslExtremeQualification";
import CslExtremeElimination from "components/sports/csl/views/CslExtremeElimination";
import CslTeam from "components/sports/csl/views/CslTeam";
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";
const CslContext = () => {
  const { mirs_rsc } = useUrlFriendlyToParameters()
  return (
    <>
      {isHeats(mirs_rsc) && <CslHeats />}
      {isFinals(mirs_rsc) && <CslFinals />}
      {isExtremeQualification(mirs_rsc) && <CslExtremeQualification />}
      {isNotExtremeQualification(mirs_rsc) && <CslExtremeElimination />}
      {isTeam(mirs_rsc) && <CslTeam />}
    </>
  );
};

export default CslContext;
